import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["addNew", "extendedRangeForm", "numberOfInterpretations"];

  static values = {
    form: String,
    minInter: Number,
    maxInter: Number,
  };

  connect() {
    $(".selectpicker").selectpicker();
    if (this.formValue == "edit") {
      return;
    } else {
      this.clearAllForms();
    }
  }

  clearAllForms() {
    this.extendedRangeFormTargets.forEach((el) => {
      if (this.extendedRangeFormTargets.length == this.minInterValue ) {
        return;
      }

      el.remove();
      this.numberOfInterpretationsTarget.value = this.extendedRangeFormTargets.length;
    });

    this.extendedRangeFormTargets.forEach((el)=>{
      el.querySelectorAll("input").forEach((input) => {
        input.value = "";
        input.checked = false;
      });
    })
  }

  deleteRange(e) {
    e.preventDefault();

    if (this.numberOfInterpretationsTarget.value <= this.minInterValue) {
      return;
    }
    this.minusInterpretations();

    const lastElement =
      this.extendedRangeFormTargets[this.extendedRangeFormTargets.length - 1];
    lastElement.remove();
  }

  addRange(e) {
    e.preventDefault();

    if (this.extendedRangeFormTargets.length >= this.maxInterValue) {
      return;
    }
    this.plusInterpretations();

    const lastElement =
      this.extendedRangeFormTargets[this.extendedRangeFormTargets.length - 1];
    const firstElement = this.extendedRangeFormTargets[0];

    if (!firstElement) {
      return;
    }

    let clone = firstElement.cloneNode(true);
    clone.id = `range-${this.extendedRangeFormTargets.length + 1}`;
    clone.querySelectorAll("input").forEach((input) => {
      input.value = "";
      input.checked = false;
    });

    $(clone)
      .find(".bootstrap-select")
      .replaceWith(function () {
        return $("select", this);
      });
    $(clone).find(".selectpicker").selectpicker("refresh");
    $(clone).find(".selectpicker").val("");
    lastElement.after(clone);
  }

  plusInterpretations() {
    this.numberOfInterpretationsTarget.value =
      +this.numberOfInterpretationsTarget.value + 1;
  }

  minusInterpretations() {
    this.numberOfInterpretationsTarget.value =
      +this.numberOfInterpretationsTarget.value - 1;
  }
}
